import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  CardHeader,
  Collapse
} from "reactstrap";

import classnames from "classnames";
import { useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useProfile } from "../../../Components/Hooks/UserHooks";
import { getPaymentById as onGetPaymentDetails } from "../../../slices/thunks";

import moment from "moment";

const PaymentDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [payment, setPayment] = useState(null);
  const [col1, setcol1] = useState(true);
  const [col2, setcol2] = useState(true);
  const [col3, setcol3] = useState(true);
  useEffect(() => {
    if (id) {
      dispatch(onGetPaymentDetails(id))
        .unwrap()
        .then((data) => {
          setPayment(data);
        })
        .catch((error) => {
          console.error("Failed to fetch payment details:", error);
        });
    }
  }, [id, dispatch]);

  const formatDate = (date) => {
    return moment(date).format("DD MMM YYYY");
  };

  const formatTime = (time) => {
    return moment(time).format("h:mm A");
  };

  function togglecol1() {
    setcol1(!col1);
  }

  function togglecol2() {
    setcol2(!col2);
  }

  function togglecol3() {
    setcol3(!col3);
  }

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Payment Details" pageTitle="Payments" />
        <Row>
          <Col xl={9}>
            <Card>
              <CardHeader>
                <div className="d-flex align-items-center">
                  <h5 className="card-title flex-grow-1 mb-0">
                    Payment #{payment?.id || "N/A"}
                  </h5>
                  <div className="flex-shrink-0">
                    <Link
                      to="/payments-invoice-details"
                      className="btn btn-success btn-sm"
                    >
                      <i className="ri-download-2-fill align-middle me-1"></i>{" "}
                      Invoice
                    </Link>
                  </div>
                </div>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col md={6}>
                    <div className="d-flex mb-3">
                      <strong>Payment Type:</strong>
                      <p className="ms-3">{payment?.type || "N/A"}</p>
                    </div>
                    <div className="d-flex mb-3">
                      <strong>Tax:</strong>
                      <p className="ms-3">{payment?.tax || "N/A"}</p>
                    </div>
                    <div className="d-flex mb-3">
                      <strong>VAT Percentage:</strong>
                      <p className="ms-3">{payment?.vat_percentage || "N/A"}</p>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="d-flex mb-3">
                      <strong>Amount:</strong>
                      <p className="ms-3">{payment?.amount || "N/A"}</p>
                    </div>
                    <div className="d-flex mb-3">
                      <strong>Cashed:</strong>
                      <p className="ms-3">{payment?.cashed ? "Yes" : "No"}</p>
                    </div>
                    <div className="d-flex mb-3">
                      <strong>Booking Date:</strong>
                      <p className="ms-3">
                        {payment?.booking_date
                          ? formatDate(payment?.booking_date)
                          : "N/A"}
                      </p>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <Card>
              <CardHeader>
                <div className="d-sm-flex align-items-center">
                  <h5 className="card-title flex-grow-1 mb-0">Payment Status</h5>
                </div>
              </CardHeader>
              <CardBody>
                <div className="profile-timeline">
                  <div className="accordion accordion-flush" id="accordionFlushExample">
                    <div className="accordion-item border-0" onClick={togglecol1}>
                      <div className="accordion-header" id="headingOne">
                        <Link
                          to="#"
                          className={classnames("accordion-button", "p-2", "shadow-none", { collapsed: !col1 })}
                        >
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0 avatar-xs">
                              <div className="avatar-title bg-success rounded-circle">
                                <i className="ri-shopping-bag-line"></i>
                              </div>
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h6 className="fs-15 mb-0 fw-semibold">
                                Payment Booked -{" "}
                                <span className="fw-normal">
                                  {payment?.booking_date
                                    ? formatDate(payment?.booking_date)
                                    : "N/A"}
                                </span>
                              </h6>
                            </div>
                          </div>
                        </Link>
                      </div>
                      <Collapse id="collapseOne" className="accordion-collapse" isOpen={col1}>
                        <div className="accordion-body ms-2 ps-5 pt-0">
                          <h6 className="mb-1">Payment has been booked.</h6>
                          <p className="text-muted">{payment?.booking_date}</p>
                        </div>
                      </Collapse>
                    </div>

                    <div className="accordion-item border-0" onClick={togglecol2}>
                      <div className="accordion-header" id="headingTwo">
                        <Link
                          to="#"
                          className={classnames("accordion-button", "p-2", "shadow-none", { collapsed: !col2 })}
                        >
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0 avatar-xs">
                              <div className="avatar-title bg-success rounded-circle">
                                <i className="mdi mdi-gift-outline"></i>
                              </div>
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h6 className="fs-15 mb-1 fw-semibold">
                                Cashed -{" "}
                                <span className="fw-normal">
                                  {payment?.cashed_date
                                    ? formatDate(payment?.cashed_date)
                                    : "N/A"}
                                </span>
                              </h6>
                            </div>
                          </div>
                        </Link>
                      </div>
                      <Collapse id="collapseTwo" className="accordion-collapse" isOpen={col2}>
                        <div className="accordion-body ms-2 ps-5 pt-0">
                          <h6 className="mb-1">Payment has been cashed.</h6>
                          <p className="text-muted mb-0">{payment?.cashed_date}</p>
                        </div>
                      </Collapse>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col xl={3}>
            <Card>
              <CardHeader>
                <div className="d-flex">
                  <h5 className="card-title flex-grow-1 mb-0">
                    <i className="mdi mdi-truck-fast-outline align-middle me-1 text-muted"></i> Payment Details
                  </h5>
                </div>
              </CardHeader>
              <CardBody>
                <div className="text-center">
                  <lord-icon
                    src="https://cdn.lordicon.com/uetqnvvg.json"
                    trigger="loop"
                    colors="primary:#405189,secondary:#0ab39c"
                    style={{ width: "80px", height: "80px" }}
                  ></lord-icon>
                  <h5 className="fs-16 mt-2">RQK Logistics</h5>
                  <p className="text-muted mb-0">Payment Mode : Debit Card</p>
                </div>
              </CardBody>
            </Card>
            <Card>
              <CardHeader>
                <div className="d-flex">
                  <h5 className="card-title flex-grow-1 mb-0">Customer Details</h5>
                  <div className="flex-shrink-0">
                    <Link to="#" className="link-secondary">
                      View Profile
                    </Link>
                  </div>
                </div>
              </CardHeader>
              <CardBody>
                <ul className="list-unstyled mb-0 vstack gap-3">
                  <li>
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <img
                          src="https://via.placeholder.com/40"
                          alt=""
                          className="avatar-sm rounded"
                        />
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <h6 className="fs-14 mb-1">Joseph Parkers</h6>
                        <p className="text-muted mb-0">Customer</p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <i className="ri-mail-line me-2 align-middle text-muted fs-16"></i>
                    josephparker@gmail.com
                  </li>
                  <li>
                    <i className="ri-phone-line me-2 align-middle text-muted fs-16"></i>
                    +(256) 245451 441
                  </li>
                </ul>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PaymentDetails;
